import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import { useTranslation } from "react-i18next";
import { db, collection, query, getDocs, orderBy } from "../../firebase";
import CurrencyFormat from "react-currency-format";

const GrowingChart1 = () => {
  const { t, i18n } = useTranslation();
  const [realtime, setRealtime] = useState(0);
  const [today, setToday] = useState(0);
  const [yesterday, setYesterday] = useState(0);
  const [ipAddressTrack, setIpAddressTrack] = useState([]);
  const [todayIncrease, setTodayIncrease] = useState(0);
  const [numOfUS, setNumOfUS] = useState(0);
  const [numOfKO, setNumOfKO] = useState(0);
  const [totalVisits, setTotalVisits] = useState(0);

  const today2 = new Date();
  const yesterdayDate = new Date(today2);
  yesterdayDate.setDate(yesterdayDate.getDate() - 1);
  // console.log(yesterdayDate.getFullYear());

  // console.log("ipAddressTrack", ipAddressTrack);

  useEffect(() => {
    setIpAddressTrack([]);
    setToday(0);
    setYesterday(0);

    getVisitors();

    return () => {
      setIpAddressTrack([]);
      setToday(0);
      setYesterday(0);
    };
  }, []);

  // console.log("todayIncrease", todayIncrease);

  const getVisitors = async () => {
    //ipAddressTrack
    const q = query(collection(db, "ipAddressTrack"));
    const querySnapshot = await getDocs(q);

    let today = 0;
    let yesterday = 0;
    let countryCode_US = 0;
    let countryCode_KO = 0;
    let total = 0;

    querySnapshot.forEach(async (doc) => {
      setIpAddressTrack((old) => [...old, doc.data()]);

      if (
        doc.data().created.toDate().getFullYear() ===
          new Date().getFullYear() &&
        (doc.data().created.toDate().getMonth() === new Date().getMonth() &&
          doc.data().created.toDate().getDate()) === new Date().getDate()
      ) {
        today++;
      }

      if (
        doc.data().created.toDate().getFullYear() ===
          yesterdayDate.getFullYear() &&
        (doc.data().created.toDate().getMonth() === yesterdayDate.getMonth() &&
          doc.data().created.toDate().getDate()) === yesterdayDate.getDate()
      ) {
        yesterday++;
      }

      if ("KR" === doc.data().countryCode) {
        countryCode_KO++;
      } else {
        countryCode_US++;
      }
      // if ("US" === doc.data().countryCode)
      if (doc.data().visits) {
        total = total + +doc.data().visits;
      }
    });
    setToday(today);
    setYesterday(yesterday);
    setTodayIncrease(getPercentageIncrease(today, yesterday));
    setNumOfUS(countryCode_US);
    setNumOfKO(countryCode_KO);
    setTotalVisits(total);
  };

  function getPercentageIncrease(numA, numB) {
    if (numB === 0) {
      return 100;
    }
    return ((numA - numB) / numB) * 100;
  }

  return (
    <Grid container>
      <Grid
        item
        md={12}
        sm={12}
        xs={12}
        sx={{ backgroundColor: "white", mt: 2 }}
      >
        <Box sx={{ p: 3, color: "#b6b7c1", fontSize: "13px" }}>
          GROWING CHART
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-around",
            mb: 3,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Box
              style={{
                backgroundColor: "#f5f6fb",
                width: "50px",
                height: "50px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "20px",
              }}
            >
              <img src="/img/user_1.png" width="20" height="20" />
            </Box>
            <Box sx={{ color: "#1a2027", pl: 2 }}>
              <Box sx={{ fontSize: "14px" }}>
                {t("Total Number of Visitors")}
              </Box>
              <Box
                sx={{
                  color: "black",
                  fontWeight: 600,
                  fontSize: "22px",
                  display: "flex",
                  pt: 1,
                }}
              >
                <Box>{ipAddressTrack.length}</Box>
                <Box
                  sx={{
                    fontSize: "14px",
                    color: "green",
                    position: "relative",
                    left: "+10px",
                  }}
                >
                  {/* <ArrowUpwardIcon
                    sx={{
                      fontSize: "13px",
                      position: "relative",
                      top: "+2px",
                    }}
                  /> */}
                  {/* 12% */}
                </Box>
              </Box>
            </Box>
          </Box>
          {/* <Box sx={{ display: "flex", alignItems: "center" }}>
            <Box
              style={{
                backgroundColor: "#f5f6fb",
                width: "50px",
                height: "50px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "20px",
              }}
            >
              <img src="/img/box.png" width="25" height="25" />
            </Box>
            <Box sx={{ color: "#1a2027", pl: 2 }}>
              <Box>{t("Realtime Users")}</Box>
              <Box
                sx={{
                  color: "black",
                  fontWeight: 600,
                  fontSize: "22px",
                  display: "flex",
                }}
              >
                <Box>1</Box>
                <Box
                  sx={{
                    fontSize: "14px",
                    color: "green",
                    position: "relative",
                    left: "+10px",
                  }}
                >
                  <ArrowUpwardIcon
                    sx={{
                      fontSize: "13px",
                      position: "relative",
                      top: "+2px",
                    }}
                  />
                  12%
                </Box>
              </Box>
            </Box>
          </Box> */}
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Box
              style={{
                backgroundColor: "#f5f6fb",
                width: "50px",
                height: "50px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "20px",
              }}
            >
              <img src="/img/user_1.png" width="20" height="20" />
            </Box>
            <Box sx={{ color: "#1a2027", pl: 2 }}>
              <Box>{t("Daily Visitors")}</Box>
              <Box
                sx={{
                  color: "black",
                  fontWeight: 600,
                  fontSize: "22px",
                  display: "flex",
                  pt: 1,
                }}
              >
                <Box>{today}</Box>
                <Box
                  sx={{
                    fontSize: "14px",
                    color: today >= yesterday ? "green" : "red",
                    position: "relative",
                    left: "+10px",
                  }}
                >
                  {today >= yesterday ? (
                    <ArrowUpwardIcon
                      sx={{
                        fontSize: "13px",
                        position: "relative",
                        top: "+2px",
                      }}
                    />
                  ) : (
                    <ArrowDownwardIcon
                      sx={{
                        fontSize: "13px",
                        position: "relative",
                        top: "+2px",
                      }}
                    />
                  )}
                  {todayIncrease.toFixed(0)}%
                </Box>
              </Box>
            </Box>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Box
              style={{
                backgroundColor: "#f5f6fb",
                width: "50px",
                height: "50px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "20px",
              }}
            >
              <img src="/img/user_1.png" width="20" height="20" />
            </Box>
            <Box sx={{ color: "#1a2027", pl: 2 }}>
              <Box>{t("Visitors in Korea")}</Box>
              <Box
                sx={{
                  color: "black",
                  fontWeight: 600,
                  fontSize: "22px",
                  display: "flex",
                  pt: 1,
                }}
              >
                <Box>{numOfKO}</Box>
                {/* <Box
                  sx={{
                    fontSize: "14px",
                    color: "green",
                    position: "relative",
                    left: "+10px",
                  }}
                >
                  <ArrowUpwardIcon
                    sx={{
                      fontSize: "13px",
                      position: "relative",
                      top: "+2px",
                    }}
                  />
                  12%
                </Box> */}
              </Box>
            </Box>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Box
              style={{
                backgroundColor: "#f5f6fb",
                width: "50px",
                height: "50px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "20px",
              }}
            >
              <img src="/img/user_1.png" width="20" height="20" />
            </Box>
            <Box sx={{ color: "#1a2027", pl: 2 }}>
              <Box>{t("Visitors in USA")}</Box>
              <Box
                sx={{
                  color: "black",
                  fontWeight: 600,
                  fontSize: "22px",
                  display: "flex",
                  pt: 1,
                }}
              >
                <Box>{numOfUS}</Box>
                {/* <Box
                  sx={{
                    fontSize: "14px",
                    color: "green",
                    position: "relative",
                    left: "+10px",
                  }}
                >
                  <ArrowUpwardIcon
                    sx={{
                      fontSize: "13px",
                      position: "relative",
                      top: "+2px",
                    }}
                  />
                  12%
                </Box> */}
              </Box>
            </Box>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Box
              style={{
                backgroundColor: "#f5f6fb",
                width: "50px",
                height: "50px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "20px",
              }}
            >
              <img src="/img/user_1.png" width="20" height="20" />
            </Box>
            <Box sx={{ color: "#1a2027", pl: 2 }}>
              <Box>누적 방문 수</Box>
              <Box
                sx={{
                  color: "black",
                  fontWeight: 600,
                  fontSize: "22px",
                  display: "flex",
                  pt: 1,
                }}
              >
                <Box>
                  <CurrencyFormat
                    value={totalVisits}
                    displayType={"text"}
                    thousandSeparator={true}
                  />
                </Box>
                {/* <Box
                  sx={{
                    fontSize: "14px",
                    color: "green",
                    position: "relative",
                    left: "+10px",
                  }}
                >
                  <ArrowUpwardIcon
                    sx={{
                      fontSize: "13px",
                      position: "relative",
                      top: "+2px",
                    }}
                  />
                  12%
                </Box> */}
              </Box>
            </Box>
          </Box>{" "}
        </Box>
      </Grid>
    </Grid>
  );
};

export default GrowingChart1;
